import { all, call, put, takeLatest } from 'redux-saga/effects';
import { activateQbClass, deactivateQbClass } from '../requests/QbClassRequests';
import * as uiActions from '../actions/Actions';
import * as qbClassActions from '../actions/QbClassActions';
import * as resourceActions from '../actions/BusinessResourcesActions';

export function* unhideQbClass({ qbClassId }) {
    try {
        const activatedQbClass = yield call(activateQbClass, qbClassId);
        yield put(qbClassActions.unhideQbClassSuccess(activatedQbClass));
        yield put(resourceActions.requestBusinessResources());
        yield put(uiActions.showToast('Class has been activated', 'positive'));

        // Dispatch custom event to trigger table refresh
        window.dispatchEvent(new CustomEvent('qbclass-status-updated'));
    } catch (error) {
        console.error('Error activating QB Class:', error);
        yield put(qbClassActions.unhideQbClassError(error));
        yield put(
            uiActions.showToast("Couldn't activate this class. Try again later.", 'negative')
        );
    }
}

export function* hideQbClass({ qbClassId }) {
    try {
        const deactivatedQbClass = yield call(deactivateQbClass, qbClassId);
        yield put(qbClassActions.hideQbClassSuccess(deactivatedQbClass));
        yield put(resourceActions.requestBusinessResources());
        yield put(uiActions.showToast('Class has been deactivated', 'positive'));

        // Dispatch custom event to trigger table refresh
        window.dispatchEvent(new CustomEvent('qbclass-status-updated'));
    } catch (error) {
        console.error('Error deactivating QB Class:', error);
        yield put(qbClassActions.hideQbClassError(error));
        yield put(
            uiActions.showToast("Couldn't deactivate this class. Try again later.", 'negative')
        );
    }
}

export default function* root() {
    yield all([
        takeLatest(['ACTIVATE_QB_CLASS'], unhideQbClass),
        takeLatest(['DEACTIVATE_QB_CLASS'], hideQbClass),
    ]);
}
